export const getItemFromSessionStorage = (key) => {
    if (sessionStorage.getItem(key)) {
      return JSON.parse(sessionStorage.getItem(key));
    } else {
      return undefined;
    }
  };
  
  export const setItemToSessionStorage = (key, value) => {
    if (value != null && value != undefined) {
      return sessionStorage.setItem(key, JSON.stringify(value));
    }
  };
  
  export const removeItemToSessionStorage = (key) => {
    return sessionStorage.removeItem(key);
  };
  
